import { getStorageData } from '@/utils/util';
import { getUserInfo } from '@/api/user';

const resetState = {
	isLogin: false,
	userName: '',
	userId: '',
	photo: '',
	userToken: '',
	appLogoURL: ''
};

const actions = {
	async updateUserInfo({ commit, state, rootState }, payload) {
		const userToken = await getStorageData(`user_token_${rootState.appid}`);

		if (!userToken) {
			commit('UPDATE_USER_INFO', {
				...resetState
			});
			return;
		}

		try {
			const res = await getUserInfo({
				token: userToken,
				appid: rootState.appid
			});

			commit('UPDATE_USER_INFO', {
				isLogin: true,
				userName: res.data.nickname,
				photo: res.data.avatar,
				userId: res.data.fake_id,
				appLogoURL: res.data.logo_url,
				userToken
			});
		}
		catch(err) {
			commit('UPDATE_USER_INFO', {
				...resetState
			});
		}
	},

	async updateUserToken({ commit, state, rootState }, payload) {
		commit('UPDATE_USER_TOKEN', {
			userToken: payload.userToken || ''
		});
	},
}

export default actions;
